import { ReactNode } from "react";
import { Alert, Box } from "@mui/material";

interface RegionWarningProps {
    enabled: boolean;
    region: string;
    children: ReactNode;
}

const RegionWarning = ({ enabled, region, children }: RegionWarningProps) => {
    if (!enabled || (enabled && region === "-1")) return children;

    return (
        <Box
            sx={{
                backgroundImage: `repeating-linear-gradient(-45deg, transparent, transparent 20px, rgba(255, 244, 229, 0.5) 20px, rgba(255, 244, 229, 0.5)  40px)`,
            }}
        >
            <Box sx={{ p: (theme) => theme.spacing(2) }}>
                <Alert severity="warning">
                    This container is only visible in the following region: <strong>{region}</strong>.
                </Alert>
            </Box>

            {children}
        </Box>
    );
};

export default RegionWarning;
